import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { FaCalendarAlt, FaEllipsisV, FaPlus } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FiDownload,
  FiFileText,
  FiTrash2,
  FiChevronDown,
} from "react-icons/fi";
import CandidatesHeader from "../../components/administration/Candidates/CandidatesHeader";
const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];
const CandidatesKanban = () => {

           const [selected, setSelected] = useState("03/27/2026 - 04/02/2026");
      const [open, setOpen] = useState(false);
        const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);
  };
  const data = [
    {
      title: "New",
      color: "#6f42c1",
      count: 30,
      cards: [
        {
          id: "Cand-001",
          name: "Harold Gaynor",
          role: "Accountant",
          date: "12 Sep 2024",
          img: "/assets/img/users/user-39.jpg",
        },
        {
          id: "Cand-002",
          name: "Sandra Ornellas",
          role: "Accountant",
          date: "12 Sep 2024",
          img: "/assets/img/users/user-40.jpg",
        },
      ],
    },
    {
      title: "Scheduled",
      color: "#e83e8c",
      count: 30,
      cards: [
        {
          id: "Cand-003",
          name: "John Harris",
          role: "Technician",
          date: "12 Sep 2024",
          img: "/assets/img/users/user-41.jpg",
        },
      ],
    },
    {
      title: "Interviewed",
      color: "#0d6efd",
      count: 30,
      cards: [
        {
          id: "Cand-007",
          name: "David Carmona",
          role: "Manager",
          date: "12 Sep 2024",
          img: "/assets/img/users/user-46.jpg",
        },
      ],
    },
    {
      title: "Offered",
      color: "#ffc107",
      count: 30,
      cards: [
        {
          id: "Cand-010",
          name: "Joyce Golston",
          role: "Business",
          date: "12 Sep 2024",
          img: "/assets/img/users/user-47.jpg",
        },
      ],
    },
    {
      title: "Hired",
      color: "#198754",
      count: 30,
      cards: [
        {
          id: "Cand-012",
          name: "Lillie Diaz",
          role: "Receptionist",
          date: "12 Sep 2024",
          img: "/assets/img/users/user-50.jpg",
        },
      ],
    },
  ];

  return (
    <div  style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }} className="container-fluid ">

     <CandidatesHeader/>
      {/* HEADER */}
      <div className="card p-3 mb-3" style={{ borderRadius: "6px", border:"border:4px solid #e5e7eb;", }}>
        <div className="d-flex justify-content-between flex-wrap gap-3">
          <h5 className="fw-bold">Candidates Kanban</h5>

          <div className="d-flex flex-wrap gap-2">
            {/* DATE */}
    <div className="date-dropdown-wrapper">

      {/* INPUT BOX */}
      <div
        className="input-box"
        onClick={() => setOpen(!open)}
      >
        <input value={selected} readOnly />
        <FiChevronDown />
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className="date-dropdown-menu">
          {options.map((item, i) => (
            <div
              key={i}
              className={`dropdown-item-custom ${
                item === selected ? "active" : ""
              }`}
              onClick={() => handleSelect(item)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>

            {/* ROLE */}
            <Dropdown>
              <Dropdown.Toggle variant="light">Role</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Accountant</Dropdown.Item>
                <Dropdown.Item>Developer</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* STATUS */}
            <Dropdown>
              <Dropdown.Toggle variant="light">
                Select Status
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Scheduled</Dropdown.Item>
                <Dropdown.Item>Interviewed</Dropdown.Item>
                <Dropdown.Item>Offered</Dropdown.Item>
                <Dropdown.Item>Hired</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* SORT */}
            <Dropdown>
              <Dropdown.Toggle variant="light">
                Sort By : Last 7 Days
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Ascending</Dropdown.Item>
                <Dropdown.Item>Descending</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* KANBAN */}
      <div style={{ display: "flex", gap: "15px", overflowX: "auto" }}>
        {data.map((col, i) => (
          <div
            key={i}
            style={{
              minWidth: "280px",
              background: "#f5f6f8",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            {/* COLUMN HEADER */}
            <div
              style={{
                background: "#ffff",
                padding: "10px",
                borderRadius: "5px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <div className="d-flex align-items-center">
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    background: col.color,
                  }}
                ></span>
                <h6 className="ms-2 mb-0">{col.title}</h6>
                <span className="badge bg-light ms-2">{col.count}</span>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle variant="light" size="sm">
                  <FaEllipsisV />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Edit</Dropdown.Item>
                  <Dropdown.Item>Delete</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {/* CARDS */}
            {col.cards.map((card, idx) => (
              <div
                key={idx}
                className="card mb-2 p-2"
                style={{
                  borderRadius: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="badge bg-light text-danger">
                      {card.id}
                    </span>

                    <Dropdown align="end">
                      <Dropdown.Toggle variant="light" size="sm">
                        <FaEllipsisV />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>Delete</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <img
                      src={card.img}
                      alt=""
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "8px",
                        marginRight: "10px",
                      }}
                    />
                    <div>
                      <h6 className="mb-0">{card.name}</h6>
                      <small className="text-muted">
                        [email protected]
                      </small>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between small">
                    <div>
                      <div className="text-muted">Applied Role</div>
                      <div>{card.role}</div>
                    </div>

                    <div>
                      <div className="text-muted">Applied Date</div>
                      <div>{card.date}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* ADD BUTTON */}
            <button
              style={{
                width: "100%",
                border: "1px dashed #ccc",
                background: "#fff",
                padding: "8px",
                borderRadius: "8px",
                marginTop: "10px",
              }}
            >
              <FaPlus className="me-2" />
              New Project
            </button>
          </div>
        ))}
      </div>
      <style>
          {

               `
               .kanban-header {
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 0 1px 1px rgba(0,0,0,0.05);

}

.date-box {
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.kanban-scroll {
  overflow-x: auto;
  padding-bottom: 10px;
}

.kanban-column {
  min-width: 280px;
  background: #f5f6f8;
  padding: 10px;
  border-radius: 10px;
}

.column-header {
  background: white;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.kanban-card {
padding:"3px"
border-radius:5px;
border:2px solid #e5e7eb;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.add-btn {
  width: 100%;
  border: 1px dashed #ccc;
  background: white;
  padding: 8px;
  border-radius: 8px;
  margin-top: 10px;
}

// dates
/* WRAPPER */
.date-dropdown-wrapper {
  position: relative;
  width: auto;
}

/* INPUT BOX */
.input-box {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  cursor: pointer;
}

.input-box input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  cursor: pointer;
}

/* DROPDOWN */
.date-dropdown-menu {
  position: absolute;
  top: 45px;
  width: 15%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  z-index: 999;
  overflow: hidden;
}

/* ITEM */
.dropdown-item-custom {
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
}

/* HOVER */
.dropdown-item-custom:hover {
  background: #ef8019;
}

/* ACTIVE (ORANGE LIKE IMAGE) */
.dropdown-item-custom.active {
  background: #ff6b1a;
  color: #fff;
}

/* SMALL ARROW (OPTIONAL) */
.date-dropdown-menu::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;
  width: 10px;
  height: 10px;
  background: white;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  transform: rotate(45deg);
}

/* MOBILE */
@media (max-width: 768px) {
  .kanban-column {
    min-width: 90%;
  }
}`
          }
      </style>
    </div>
  );
};

export default CandidatesKanban;